<template>
  <div class="position-r box">
    <!--banner-->
    <div class="index-banner" @click="goToUrl">
      <div class="f24 fw">欢迎使用</div>
      <div class="f24 fw"><span class="color-09">陪一会</span>共享轮椅</div>
      <div class="pt5 flex-fs">
        <div class="mr8 photo-icon">
          <img :src="headPhoto" alt="" class="head-img" />
        </div>
        <span>{{ userName }}</span>
      </div>
    </div>
    <div class="flexJC p15">
      <div class="content-box" v-show="isMz == true">
        <div class="flexJC alignItem text-over">
          <div class="flex-fs fw">
            <i class="icon-con icon_lb"></i>
            <span class="f16 color-3 mt-3">{{
              filterFun(cabinetInfo && cabinetInfo.cabinet.placeName)
            }}</span>
          </div>
          <div class="f16 color-9 pt10">
            <p>租用时间为以下时间段内开放</p>
            <p class="mt10" v-for="item in timerList">
              {{ item.startTime }}-{{ item.endTime }}
            </p>
          </div>
          <p class="pt10" v-show="timerList && timerList.length > 0 && timerList[0].overMoney">
            超时费用为：<span class="f18 color-09">{{
              timerList && timerList.length > 0
                ? timerList[0].overMoney
                  ? timerList[0].overMoney
                  : 0
                : 0
            }}</span>元
          </p>
          <div class="flex mt36">
            <button class="btn-lx btn-width btn-lx-width" @click="tautologyFun">
              重试
            </button>
          </div>
        </div>
      </div>
      <div class="" v-show="isMz == false">
        <!--租借-->
        <div class="content-box" v-show="isNormal == 1 && isBackBed == false">
          <div class="flexJC alignItem">
            <div class="flex-fs fw">
              <i class="icon-con icon_lb"></i>
              <span class="f16 color-3 mt-3">{{
                filterFun(cabinetInfo && cabinetInfo.cabinet.placeName)
              }}</span>
            </div>
            <h3 class="f20 color-3 pt10">
              可用轮椅铺仅剩<span class="color-09">{{ number }}</span>张
            </h3>
            <div class="bed-img pt10 pb15">
              <img src="../../../static/images/icon_chuang.png" alt="" />
            </div>
            <div class="flex mt36 flexJC alignItem">
              <!--<button class="btn-lx btn-lx-width mb20" :disabled="number ==0 || isDisabled ==true" :class="(number ==0 || isDisabled ==true)?'unSubmit':'btn-width'" @click="postBorrowBed">立即租借</button>-->
              <button class="btn-lx btn-lx-width" :disabled="number == 0 || isZm == true" :class="number == 0 || isZm == true ? 'unSubmit' : 'btn-width'" @click="postZmGrant">
                免押租借<span class="displsy-block" style="font-size: 8px">芝麻信用分600以上</span>
              </button>
            </div>
            <div class="flex-fs pt20">
              <router-link tag="div" to="/agreement" class="f10 color-9 mr10">用户协议</router-link>
              <router-link tag="div" to="/expenses" class="f10 color-9">计费规则</router-link>
            </div>
          </div>
        </div>
        <!--归还-->
        <div class="content-box" v-show="isBackBed == true">
          <div class="text-center fw">
            {{ list && list.placeName }}
          </div>
          <div class="pt10 f14 color-9">
            <div class="flexJC-sb pb10 border-b">
              <span>起租时间</span>
              <span>{{
                list && list.beginTime ? dateFormatter(list.beginTime) : ""
              }}</span>
            </div>
            <div class="flexJC-sb pb10 border-b pt10">
              <span>累计用时</span>
              <span>{{ list && list.useTime }}</span>
            </div>
            <div class="flexJC-sb pb10 border-b pt10">
              <span>累计正常计费</span>
              <span class="">{{
                  list && list.passNorMalMoney
                    ? list && list.passNorMalMoney
                    : "0"
                }}元</span>
            </div>
            <div class="flexJC-sb pb10 border-b pt10">
              <span>累计超时计费</span>
              <span class="">{{
                  list && list.passOverMoney ? list && list.passOverMoney : "0"
                }}元</span>
            </div>
            <div class="flexJC-sb pb10 border-b pt10">
              <span>累计总金额</span>
              <span class="">{{
                  list && list.passMoney ? list && list.passMoney : "0"
                }}元</span>
            </div>
            <div class="flexJC-sb pt10">
              <span class="f16 color-2 fw">退款预收金额(参考)：</span>
              <div class="color-38">
                <span class="f24 fw">
                  {{
                    parseInt(list && list.depositMoney) -
                      parseInt(list && list.passMoney) >
                    0
                      ? parseInt(list && list.depositMoney) -
                        parseInt(list && list.passMoney)
                      : "0"
                  }}
                </span>
                <span class="f16">元</span>
              </div>
            </div>
          </div>
        </div>
        <!--设备异常-->
        <div class="content-box" v-show="isNormal == 3 || isNormal == 5">
          <div class="flexJC alignItem text-over">
            <div class="flex-fs fw">
              <i class="icon-con icon_lb"></i>
              <span class="f16 color-3 text-over mt-3">{{
                cabinetInfo && cabinetInfo.cabinet.placeName
              }}</span>
            </div>
            <div class="pt18">
              <div class="noNormal">
                <img src="../../../static/images/icon_noNarmal.png" alt="" />
              </div>
              <div class="f16 color-9 pt10">
                设备{{ isNormal == 5 ? "不在线" : "异常" }}
              </div>
              <div class="f16 color-9 pt10">
                <p>为您带来的不便我们深表歉意</p>
                <p class="mt5">请联系客服为您解决</p>
              </div>
            </div>
          </div>
          <div class="flex mt36">
            <a href="tel:400-688-1003" class="btn-lx btn-lx-width">联系客服</a>
          </div>
        </div>
        <!--没有设备-->
        <div class="content-box" v-show="isNormal == 4">
          <div class="flexJC alignItem text-over">
            <div class="pt18">
              <div class="noNormal">
                <img src="../../../static/images/icon_noNarmal.png" alt="" />
              </div>
              <div class="f16 color-9 pt10">暂无设备</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p15" v-show="isBackBed == false">
      <div class="banner">
        <mt-swipe :auto="8000">
          <mt-swipe-item>
            <div class="cabinet-box flexJC alignItem cabinet-content" @click="goToUrl">
              <div class="fw f20">
                每小时<span class="color-09">{{
                  cabinetInfo && cabinetInfo.cabinet.chargeMoney
                }}</span>元<span class="ml10">押金归还即退</span>
              </div>
              <div class="f14">
                预收金额<span class="f14 color-09">{{
                  cabinetInfo && cabinetInfo.cabinet.depositMoney
                    ? cabinetInfo.cabinet.depositMoney
                    : 0
                }}</span>元 <span>芝麻分600以上支付宝扫码免押</span>
              </div>
            </div>
          </mt-swipe-item>
          <mt-swipe-item v-for="item in bannerList" :key="item.advNo">
            <a @click="goToNewUrl(item.outerUrl)" class="displsy-block banner-a"><img :src="item.advUrl" alt="" class="border-radius" /></a>
          </mt-swipe-item>
        </mt-swipe>
      </div>
    </div>
    <div class="p15">
      <!--<button class="btn-con btn-color btn-width mb10" :disabled="number ==0 || isDisabled ==true" :class="(number ==0 || isDisabled ==true)?'unSubmit':''" v-if="isNormal == 1 && isBackBed == false" @click="postBorrowBed">立即租借</button>-->
      <!--<button class="btn-con btn-color btn-width" :disabled="number ==0 || isZm ==true" :class="(number ==0 || isZm ==true)?'unSubmit':''" @click="postZmGrant" v-if="isNormal == 1 && isBackBed == false">免押租借</button>-->
      <button class="btn-lx btn-lx-width btn-width" v-if="isBackBed == true" @click="postRepayBed">
        立即归还
      </button>
      <!--<a href="tel:400-688-1003" class="btn-con btn-color btn-width" v-if="isNormal == 3">联系客服</a>-->
    </div>
    <!--弹框-->
    <div class="shade" v-show="hasMore">
      <div class="flexJC alignItem showLoading">
        <img src="../../../static/images/Spinner_1.gif" alt="" class="icon_loading" />
      </div>
    </div>
    <div v-html="html"></div>
  </div>
</template>

<script>
import wxServ from "../../service/wxServ";
import cache from "../../service/cacheServ";
import userServ from "../../service/userServ";
import cabinetServ from "../../service/cabinetServ";
import mintUi from "../../lib/mint-ui";
import moment from "moment";
import zfvServ from "../../service/zfbServ";
import log from '../../lib/log'
export default {
  data() {
    return {
      headPhoto: "/static/images/touxiang@2x.png",
      userName: "",
      isLoading: true,
      isNormal: null,
      cabinetInfo: null,
      number: null,
      qrCode: null,
      bedNo: null,
      hasMore: false,
      isBackBed: null,
      list: null,
      wxId: null,
      giveBackList: null,
      alipayWap: null,
      html: "",
      isDisabled: false,
      isZm: false,
      bannerList: [],
      timerList: [],
      isMz: null,
    };
  },
  created() {
    let qrCode = this.$route.query.qrcode;
    let bedNo = this.$route.query.bedNo;
    console.log("qrcode:" + this.$route.query.qrcode);
    this.qrCode = qrCode;
    this.bedNo = bedNo;
    let userInfo = cache.get("user");
    if (userInfo && qrCode) {
      this.userName = userInfo.customerName;
      this.headPhoto = userInfo.headImgUrl
        ? userInfo.headImgUrl
        : "/static/images/touxiang@2x.png";
      this.getIsBedFun(userInfo.openId);
      this.wxId = userInfo.openId;
      this.getCabinetSta(qrCode);
      this.getBannerList("HOME");
    }
  },
  methods: {
    // 获取设备状态
    getCabinetSta(qrCode) {
      this.isLoading = false;
      cabinetServ.getCabinetStatus(qrCode).then((res) => {
        this.isLoading = true;
        if (res.code === "200") {
          if (!res.data) {
          } else {
            this.cabinetInfo = res.data;
            cache.set("cabinetInfo", res.data, true);
            if (res.data.status === "2") {
              // 设备正常
              this.isNormal = 1;
              var list = res.data.bedStructList;
              let newList = [];
              if (list.length > 0) {
                newList = list.filter((item) => item.status == 1);
              }
              console.log(newList);
              this.number = newList.length;
            } else if (res.data.status === "3") {
              // 设备离线
              this.isNormal = 2;
            } else if (res.data.status === "null") {
              // 设备离线
              this.isNormal = 5;
            } else {
              this.isNormal = 3;
            }
          }
        } else {
          this.isNormal = 4;
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    // 立即租借
    postBorrowBed() {
      let qrCode = this.qrCode;
      let bedNo = this.bedNo;
      let id = cache.get("user").openId;
      this.isDisabled = true;
      zfvServ.postZfbPay(id, qrCode, bedNo).then((res) => {
        this.isDisabled = false;
        if (res.code === "200") {
          this.html = res.data;
          this.$nextTick(() => {
            document.forms[0].submit(); //渲染支付宝支付页面
          });
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    // 查询是租借还是归还
    getIsBedFun(id) {
      this.hasMore = true;
      cabinetServ.getCabinetIsZorF(id).then((res) => {
        log.info({ url: window.location.href, loc: 'alipayIndex.vue#getIsBedFun', contents: { res }, qrcode: true })
        this.hasMore = false;
        if (res.code === "200") {
          if (res.data && res.data.length > 0) {
            this.isBackBed = true;
            // 归还
            try {
              if (2 === +this.cabinetInfo.cabinet.cabinetType || this.cabinetInfo.cabinet.cabinetNo.includes('-02')) {
                this.isBackBed = false;
              }
            } catch (error) {
              log.info({ url: window.location.href, loc: 'alipayIndex.vue#getIsBedFun-setBackBed-error', contents: { cabinetInfo: this.cabinetInfo }, qrcode: true })
            }
            this.isMz = false;
            this.list = res.data[0];
          } else {
            // 租借
            this.isBackBed = false;
            this.isNormal = 1;
            this.getTimeList(this.qrCode);
          }
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    dateFormatter(time) {
      let datetime = time;
      if (datetime == undefined) {
        return "";
      }
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },
    // 立即归还
    postRepayBed() {
      let wxId = this.wxId;
      let orderNO = this.list.orderNo;
      this.hasMore = true;
      cabinetServ.getRepayBed(wxId, orderNO).then((res) => {
        this.hasMore = false;
        if (res.code === "200") {
          this.$router.push({
            path: "/alipayGiveBackSuccess",
            query: { orderNo: orderNO },
          });
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    goToUrl() {
      window.location.href = "http://www.aigehui028.com/";
    },
    /* 免押租借*/
    postZmGrant() {
      if (this.number == 0 || this.isZm == true) return;
      this.isZm = true;
      zfvServ.postZmGrantFun(this.wxId, this.qrCode, this.bedNo).then((res10) => {
        this.isZm = false;
        if (200 === +res10.code) {
          let baseUrl = window.location.origin;
          var orderId = res10.data.grantOrderNo;
          let qrCode = this.$route.query.qrcode;
          let bedNo = this.$route.query.bedNo;
          let openId = cache.get("user").openId;
          ap.tradePay(
            {
              orderStr: res10.data.orderStr,
            },
            function (res) {
              if (res.resultCode === "9000") {
                setTimeout(function () {
                  window.location.href =
                    baseUrl +
                    "/#/alipayPaySuccess?orderNo=" +
                    orderId +
                    "&openId=" +
                    openId +
                    "&qrcode=" +
                    qrCode + "&bedNo=" + bedNo;
                }, 2000);
              } else if (res.resultCode === "4000") {
                mintUi.Toast({
                  message: "支付失败",
                  position: "bottom",
                });
              } else if (res.resultCode === "6002") {
                mintUi.Toast({
                  message: "网络连接出错",
                  position: "bottom",
                });
              } else if (res.resultCode === "6001") {
                zfvServ.postCancelZmFun(orderId, openId, qrCode, bedNo).then((res20) => {
                  mintUi.Toast({
                    message: "取消支付",
                    position: "bottom",
                  });
                });
              }
            }
          );
        }
      });
    },
    filterFun: function (value) {
      if (value && value.length > 13) {
        value = value.substring(0, 13) + "...";
      }
      return value;
    },
    // 获取广告
    getBannerList(position) {
      wxServ.getBanner(position).then((res) => {
        if (res.code === "200") {
          this.bannerList = res.data;
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    goToNewUrl(url) {
      if (url) {
        window.location.href = url;
      } else {
        return false;
      }
    },
    //获取租借时间段
    getTimeList(qrCode) {
      this.isLoading = true;
      cabinetServ.getOrderTimeList(qrCode).then((res) => {
        this.isLoading = false;
        if (res.code === "200") {
          this.timerList = res.data.timerList;
          console.log(this.timerList);
          if (res.data.timerList.length > 0) {
            var newTime = new Date();
            var nowTimes = this.getTimesTamp(
              res.data.nowDate.replace(/-/g, "/")
            );
            console.log(nowTimes);
            var yymmdd = this.formatDate(newTime, "yyyy/MM/dd");
            var list = res.data.timerList;
            var newList = [],
              iteml = {};
            list.forEach((item) => {
              iteml["startTime"] = this.getTimesTamp(
                yymmdd + " " + item.startTime + ":00"
              );
              iteml["endTime"] = this.getTimesTamp(
                yymmdd + " " + item.endTime + ":00"
              );
              if (item.startTime <= item.endTime) {
                iteml["endTime"] =
                  this.getTimesTamp(yymmdd + " " + item.endTime + ":00") +
                  24 * 60 * 60 * 1000;
              }
              newList.push(iteml);
            });
            console.log(newList);
            if (newList.length > 0) {
              newList.forEach((item) => {
                if (item.startTime <= nowTimes && nowTimes <= item.endTime) {
                  this.isMz = false;
                  //                                        this.getCabinetSta(qrCode)
                } else {
                  this.isMz = true;
                }
              });
            }
          } else {
            this.isMz = false;
          }
        }
      });
    },
    formatDate(datetime, fmt = "yyyy/MM/dd hh:mm:ss") {
      let date = new Date();
      date.setTime(Date.parse(datetime));
      const o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        "S+": date.getMilliseconds(), // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
        );
      }
      for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
          ); //eslint-disable-line
        }
      }
      return fmt;
    },
    // 时间戳
    getTimesTamp(time) {
      return new Date(time).getTime();
    },
    tautologyFun() {
      this.getTimeList(this.qrCode);
    },
  },
  mounted() {
    // this.getCabinetSta(this.qrCode)
  },
};
</script>

<style lang="less" scoped>
@import "../../less/_var.less";
@import "../../less/index.less";
.index-banner {
  padding: 26px 25px 0 25px;
  text-align: left;
  color: #fff;
}
.pt5 {
  padding-top: 5px;
}
.loadingImg {
  width: 100px;
  height: 100px;
}
.loading-con {
  width: 70%;
  margin-left: -35%;
}
.banner {
  height: 120px;
}
.banner img {
  width: 100%;
  height: 100%;
}
.photo-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
}
.photo-icon img {
  width: 100%;
  height: 100%;
}
.userInfo {
  position: absolute;
  left: 90px;
  top: 15px;
  right: 16px;
}
.icon_lb {
  background: url("../../../static/images/icon_position.png") no-repeat;
  background-size: 100% 100%;
  width: 14px;
  height: 16px;
}
.bed-img {
  width: 231px;
  height: 95px;
}
.bed-img img {
  width: 100%;
  height: 100%;
}
.icon-fy {
  background: url("../../../static/images/icon_fy.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.mt-3 {
  margin-top: -2px;
}
.icon-sb {
  background: url("../../../static/images/icon_sb.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.icon_loading {
  width: 60px;
  height: 60px;
}
.head-img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
}
.unSubmit {
  background-color: #808080;
  color: #fff;
  border-color: #808080;
}
</style>



// WEBPACK FOOTER //
// src/pages/alipay/alipayIndex.vue